import { AxiosRequestConfig } from "axios";

import api from "@services/axios/originacao";
import { ICustomApiOptions, ICustomRequestConfig, useApi } from "./useApi";

export function useApiOriginacao<T, D = unknown>(
  baseConfig: AxiosRequestConfig<D> & ICustomRequestConfig<D, T>,
  customConfig?: ICustomApiOptions,
) {
  return useApi<T, D>(
    api,
    {
      ...baseConfig,
      headers: {
        ...baseConfig.headers,
        // "x-byx-origin": "originacao",
      },
    },
    customConfig,
  );
}
